import React, { useEffect, useState } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, TextField, TextareaAutosize, MenuItem } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { CORP_BLUE } from '../../../config/config';
import { width } from '@mui/system';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        backgroundColor: CORP_BLUE,
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: 'white',
            fontWeight: 'bold'
        },

    },
}));



const DecisionModal = (props) => {

    const { title, body, accept, cancel, closeModal, submitModal, openDialog, tramite, hideFields } = props

    const [loading, setLoading] = useState(false);
    const { innerWidth: width/*, innerHeight: height*/ } = window;
    const [solicitante, setSolicitante] = useState('')
    const [queSolicita, setQueSolicita] = useState('')
    const [observaciones, setObservaciones] = useState('')
    const [validateForm, setValidateForm] = useState(true)
    const [solicitanteError,setSolicitanteError]= useState('')
    const [queSolicitaError,setQueSolicitaError]=useState('')
    const [prioridad, setPrioridad] = useState(0)
    const [prioridadLabel, setPrioridadLabel] = useState('Prioridad')
    const [prioridadError, setPrioridadError] = useState('')
    const classes = addStyle();

    useEffect(()=>{
        if (validarModal()) {
            setValidateForm(false)
        } else {
            setValidateForm(true)
        }
    },[prioridad])

    const clearData = () => {
        setSolicitante('')
        setQueSolicita('')
        setObservaciones('')
        setSolicitanteError('')
        setQueSolicitaError('')
        setPrioridad(0)
        setPrioridadLabel('Prioridad')
        setPrioridadError('')
        setValidateForm(true)
    }

    const onCloseDialog = () => {
        clearData()
        closeModal()
    }

    const onSubmitClick = () => {
        let aux = {
            ...tramite,
            solicitud: queSolicita,
            observaciones: observaciones,
            usuario_solicitante: solicitante,
            prioridad:prioridad
        }

        submitModal(aux)
    };

    const changeSolicitante = evt => {
        setSolicitante(evt.target.value)
    }

    const changeQueSolicita = evt => {
        setQueSolicita(evt.target.value)
    }

    const changeObservaciones = evt => {
        setObservaciones(evt.target.value)
    }

    const getStyle = () => {
        if(validateForm){

        }else{
            return {backgroundColor: CORP_BLUE, color: 'white'}
        }
    }

    const validarModal = () => {
        if(solicitante === '' || queSolicita === '' || prioridad===0){
            return false
        } else{
            return true
        }
    }

    const handleChangePrioridad = evt => {
        if (evt.target.value === 0) {
            setPrioridadError('Éste campo es requerido.')
            setPrioridadLabel('*Prioridad')
        } else {
            setPrioridadError('')
            setPrioridadLabel('Prioridad')
        }

        setPrioridad(evt.target.value)
    }

    const getWidth = () => {

        if(width>500){
            return { minWidth: 500 }
        } else{
           return {}
        }
    }


    return (


        <Dialog open={openDialog} onClose={onCloseDialog} style={getWidth()}>

            <DialogTitle className={classes.dialogTitleRoot}> {title + ': ' + tramite.folio} </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center">
                    {
                        hideFields ? <p>{body}</p>
                            :
                            tramite !== '' ?
                                <p>{'¿Desea monitorear el trámite: ' + tramite.folio + ' que se encuentra en etapa de ' + tramite.fase.nombre + '?'} </p>
                                :
                                null
                    }
                </Box>
                <div hidden={hideFields}>
                    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Solicitante"
                                    value={solicitante}
                                    onChange={changeSolicitante}
                                    onBlur={()=>{
                                        if(solicitante===''){
                                            setSolicitanteError('Éste campo es requerido.')
                                        }else{
                                            setSolicitanteError('')
                                        }
                                        if(validarModal()){
                                            setValidateForm(false)
                                        }else{
                                            setValidateForm(true)
                                        }
                                    }}
                                    error={solicitanteError}
                                />
                            </Grid>


                        </Grid>
                    </Box>
                    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    style={{ width: '100%' }}
                                    rows={2}
                                    variant="outlined"
                                    multiline
                                    label="Qué se solicita"
                                    value={queSolicita}
                                    onChange={changeQueSolicita}
                                    onBlur={()=>{
                                        if(queSolicita===''){
                                            setQueSolicitaError('Éste campo es requerido.')
                                        }else{
                                            setQueSolicitaError('')
                                        }
                                        if(validarModal()){
                                            
                                            setValidateForm(false)
                                        }else{
                                            
                                            setValidateForm(true)
                                        }
                                    }}
                                    error={queSolicitaError}

                                />
                            </Grid>

                        </Grid>
                    </Box>

                    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    style={{ width: '100%' }}
                                    rows={2}
                                    variant="outlined"
                                    multiline
                                    label="Observaciones"
                                    value={observaciones}
                                    onChange={changeObservaciones}

                                />
                            </Grid>

                        </Grid>
                    </Box>

                    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                            <TextField
                                name="select_prioridad"
                                fullWidth
                                select
                                variant="outlined"
                                label={prioridadLabel}
                                value={prioridad}
                                onChange={handleChangePrioridad}
                                onBlur={() => {
                                    validarModal()
                                }}
                                error={prioridadError}
                            >
                                <MenuItem key={0} value={0}>Seleccione</MenuItem>
                                <MenuItem key={10} value={1}>Alta</MenuItem>
                                <MenuItem key={20} value={2}>Media</MenuItem>
                                <MenuItem key={30} value={3}>Baja</MenuItem>
                            </TextField>
                            </Grid>

                        </Grid>
                    </Box>
                </div>
                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} variant='contained' disabled={loading}>
                        {cancel}
                    </Button>
                    <Box ml={2}>
                        {hideFields ?
                            <Button variant="contained" style={{ backgroundColor: CORP_BLUE, color: 'white' }} onClick={onSubmitClick} disabled={loading}>
                                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : accept}
                            </Button>
                            :
                            <Button disabled={validateForm} variant="contained" style={getStyle()} onClick={()=>{
                                if(validarModal()){
                                    onSubmitClick()
                                }else{
                                    setValidateForm(true)
                                }
                            }}>
                                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : accept}
                            </Button>
                        }
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>

    );
};

export default DecisionModal;